import presbyterian from "@/static/logos/presbyterian-logo-red.svg";
import eh from "@/static/logos/eh-logo.svg";
import favicon_php from "@/static/favicons/favicon-php.svg";
import favicon_eh from "@/static/favicons/favicon-eh.svg";

import judiHealth from "@/static/logos/judi-health-horizontal-white.png";
import stLukes from "@/static/logos/st-lukes-logo.png";
import favicon_st_lukes from "@/static/favicons/favicon-st-lukes.ico";

export interface ThemeConfig {
  logo?: string;
  banner_color?: string;
  primary_color?: string;
  favicon?: string;
  header_text_color: string;
  showPA: boolean;
  showPharmacy: boolean;
  showPatient: boolean;
  showBilling: boolean;
  showMedicalClaims: boolean;
}


export interface ThemeMap {
  [key: string]: ThemeConfig;
}

export const THEMES: ThemeMap = {
  default: {
    logo: judiHealth,
    banner_color: "linear-gradient(270deg, #44659E 0%, #395992 50.1%, #14316B 99.2%)",
    primary_color: "#0071B3",
    favicon: undefined,
    header_text_color: "#FFFFFF",
    showPA: true,
    showPharmacy: true,
    showPatient: true,
    showBilling: true,
    showMedicalClaims: true,
  },
  presbyterian: {
    logo: presbyterian,
    banner_color: "linear-gradient(270deg, #D4203D 0%, #A71930 50%, #891527 100%)",
    primary_color: "#A71930",
    favicon: favicon_php,
    header_text_color: "#FFFFFF",
    showPA: true,
    showPharmacy: true,
    showPatient: true,
    showBilling: true,
    showMedicalClaims: false,
  },
  emblem: {
    logo: eh,
    banner_color: "linear-gradient(270deg, #EBE2F5 0%, #EBE2F5 50%, #EBE2F5 100%)",
    primary_color: "#490E67",
    favicon: favicon_eh,
    header_text_color: "#490E67",
    showPA: true,
    showPharmacy: true,
    showPatient: true,
    showBilling: true,
    showMedicalClaims: false,
  },
  prime: {
    logo: eh,
    banner_color: "linear-gradient(270deg, #EBE2F5 0%, #EBE2F5 50%, #EBE2F5 100%)",
    primary_color: "#490E67",
    favicon: favicon_eh,
    header_text_color: "#490E67",
    showPA: true,
    showPharmacy: false,
    showPatient: false,
    showBilling: false,
    showMedicalClaims: false,
  },
  "st-lukes": {
    logo: stLukes,
    banner_color: "linear-gradient(270deg, #0057B8 100%, #0057B8 100%, #0057B8 100%)",
    primary_color: "#0057B8",
    favicon: favicon_st_lukes,
    header_text_color: "#FFFFFF",
    showPA: true,
    showPharmacy: false,
    showPatient: false,
    showBilling: false,
    showMedicalClaims: false,
  },
};
